<template>
  <div>
    <v-autocomplete
      v-model="innerValue"
      dense
      :loading="loading"
      :items="items"
      return-object
      chips
      deletable-chips
      clearable
      item-value="id"
      tags
      :disabled="myself"
      :rules="required ? [(v) => !!v] : []"
      :multiple="multiple"
      :label="label"
      :item-text="
        (item) => {
          return itemText(item)
        }
      "
      @change="onChange"
    />
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex"

import { FETCH } from "@/store/action-types"
import PickerMixin from "@/mixins/PickerMixin"

const { mapActions } = createNamespacedHelpers("user")
export default {
  name: "UserPicker",
  props: {
    role: {
      type: String,
      default: "PEF",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      users: [],
    }
  },
  mixins: [PickerMixin],
  computed: {
    items() {
      return this.users
    },
    myself() {
      if (this.readonly) {
        return true
      }
      if (this.role === "PEF") {
        return ["PEF", "ASPIRANT"].includes(this.current_user.role)
      }
      if (this.role === "COACH") {
        return ["COACH", "CHIEF", "PEF", "ASPIRANT"].includes(
          this.current_user.role
        )
      }
      return true
    },
    current_user() {
      return this.$store.state.user.profile
    },
  },
  mounted() {
    if (this.myself) {
      this.$emit("input", this.current_user)
    }
  },
  methods: {
    ...mapActions([FETCH]),
    itemText(item) {
      return item.first_name + " " + item.last_name
    },
    async fetchData() {
      this.loading = true
      this.FETCH({ role: this.role, limit: -1, offset: 0, archived: false })
        .then((res) => {
          this.users = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
